import { render, staticRenderFns } from "./sentenceM8.vue?vue&type=template&id=75193bd8&scoped=true&"
import script from "./sentenceM8.vue?vue&type=script&lang=js&"
export * from "./sentenceM8.vue?vue&type=script&lang=js&"
import style0 from "./sentenceM8.vue?vue&type=style&index=0&id=75193bd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75193bd8",
  null
  
)

export default component.exports